<template>
  <div>
    <v-data-table dense :headers="headers" :items="desserts" :search="search" sort-by="id" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Все пользователи системы</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <v-text-field v-model="search" append-icon="search" clearable label="Поиск ..." single-line
            hide-details></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.role="{ item }">
        {{ getRoleName(item.role) }}
      </template>
      <template v-slot:item.active="{ item }">
        <v-chip class="activate" :class="[item.active ? `white--text` : '']" x-small :color="getColor(item.active)"
          @click="setActivate(item)">{{ getBool(item.active) }}</v-chip>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon normal class="removes mr-2" @click="removeUserDialog(item)">delete_forever</v-icon>
        <v-icon small @click="recoverByEmail(item.email)" title="Отправить восстановление пароля">mail</v-icon>
      </template>
    </v-data-table>
    <v-progress-linear :active="loading" :indeterminate="loading" absolute bottom
      color="deep-purple accent-4"></v-progress-linear>
    <DeleteUser v-model="removeDialog" @close="removeDialog = false" :userInfo="removeItem" @save="removeUser()" />
  </div>
</template>

<style scoped lang='sass'>
.activate
  cursor: pointer
</style>
<script>
import Swal from "sweetalert2";
import DeleteUser from "@/components/DeleteUser.vue";

export default {
  components: { DeleteUser },
  data: () => ({
    search: "",
    dialog: false,
    loading: false,
    headers: [
      {
        text: "email",
        align: "left",
        sortable: false,
        value: "email",
      },
      { text: "Фамилия", value: "famil" },
      { text: "Имя", value: "name" },
      { text: "№ телефона", value: "phone" },
      { text: "Организация", value: "orgName" },
      { text: "Инн организации", value: "inn" },
      { text: "Дата активации", value: "email_verified_at" },
      { text: "Роль", value: "role" },
      { text: "Активен", value: "active" },
      { text: "Действия", value: "action" },
    ],
    removeDialog: false,
    removeItem: null,
  }),

  computed: {
    desserts() {
      return this.$store.getters.GetUsersUM;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    //this.initialize()
  },
  async mounted() {
    await this.$store.dispatch("GetUserManagementSettings")
  },
  methods: {
    removeUserDialog(item) {
      this.removeItem = item;
      this.removeDialog = true;
    },
    async removeUser() {
      this.loading = true;
      const user = this.removeItem;
      await this.$store.dispatch("REMOVE_USER", {
        _id: user.user_id,
      });
      const id = this.$store.getters.GetCurrentOrganisationIDUM;
      this.$store.dispatch("getUsersOfOrganisation", { id }).then((res) => {
        this.loading = false;
        this.removeDialog = false;
        this.$store.dispatch("GetUserManagementSettings");
      });
    },

    getBool(val) {
      if (val) return "Да";
      else return "Нет";
    },
    getColor(color) {
      if (color) return "red";
      return "transparent";
    },

    setActivate(user) {
      const makeGoodField = (val) => {
        if (!val) return "";
        else return val;
      };
      const data = {
        id: user.user_id,
        famil: makeGoodField(user.famil),
        name: makeGoodField(user.profile_name),
        otch: makeGoodField(user.otch),
        position: makeGoodField(user.position),
        phone: makeGoodField(user.phone),
        phone_note: makeGoodField(user.phone_note),
        address: makeGoodField(user.address),
        bio: makeGoodField(user.bio),
        date: makeGoodField(user.date),
        emailContact: user.emailContact,
        profile_active: !user.active,
        role: user.role,
      };

      this.$store.dispatch("updateUserManagementFirmSotr", data).then(() => {
        if (this.$store.getters.getErrorApi == "ADMINFOREVER") {
          Swal.fire({
            icon: "warning",
            title: "Роль не изменилась",
            text: "Нельзя лишить себя роли администратора.",
          });
        } else if (this.$store.getters.getErrorApi == "ADMINACTIVE") {
          Swal.fire({
            icon: "warning",
            title: "Роль не изменилась",
            text: "Нельзя включить или выключить свою учетку.",
          });
        } else {
          this.$store.dispatch("GetUserManagementSettings").then(() => { });
        }
      });
    },

    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialog = true

      this.loading = true;
      this.$store
        .dispatch("getOrganisationUserUM", item)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "edituser2um" });
        })
        .catch((error) => {
          this.loading = false;
          alert(error);
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },

    users(item) {
      this.loading = true;
      this.$store
        .dispatch("getUsersOfOrganisation", item)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "usersorganisationtable" });
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
};
</script>
